import { getLicenseIcon } from '../lib/licenseIcons'
import type { ServiceConfig } from '../types'

/** The icon shown before a service's name — Dashboard cards, the Sidebar, and the Settings-tab
 * preview all use this so they never drift. An admin-uploaded logo (`customIconUrl`) always wins
 * over the curated Fluent icon (`iconKey`) when set; `size` is forced via explicit width/height
 * (object-fit: contain for the image) so every service reads at the same size on a card
 * regardless of what image was actually uploaded — the upload itself doesn't need to be
 * pre-cropped to any particular size. */
export default function ServiceIcon(props: { config: ServiceConfig | undefined; size?: number }) {
  const { config, size = 20 } = props

  if (config?.customIconUrl) {
    return (
      <img
        src={config.customIconUrl}
        alt=""
        style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
      />
    )
  }

  const Icon = getLicenseIcon(config?.iconKey)
  return <Icon style={{ width: size, height: size, flexShrink: 0 }} />
}
